const additionalRecordingPage = [
    {
        path: "/editAddr",
        name: "联系地址",
        component: () => import("@views/additionalRecording/editAddr.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
        },
    },
    {
        path: "/editEmail",
        name: "我的邮箱",
        component: () => import("@views/additionalRecording/editEmail.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/editFixedPhone",
        name: "固定电话",
        component: () => import("@views/additionalRecording/editFixedPhone.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/personalConfirmation",
        name: "确认相关信息",
        component: () => import("@views/additionalRecording/personalConfirmation.vue"),
        meta: {
            title: "个人中心",
            notReturnBtn:false,
            headerBg:false,
        },
    },
    {
        path: "/personalAdditionalRecording",
        name: "信息补录",
        component: () => import("@views/additionalRecording/personalAdditionalRecording.vue"),
        meta: {
            title: "个人中心",
            showBg: false
        },
    },
    {
        path: "/taxRevenue",
        name: "税收身份声明",
        component: () => import("@views/additionalRecording/taxRevenue.vue"),
        meta: {
            title: "个人中心",
            showBg: false,
            questionName:'identityDes'
        },
    },
    {
        path: "/orgConfirmation",
        name: "确认相关信息",
        component: () => import("@views/additionalRecording/orgConfirmation.vue"),
        meta: {
            title: "个人中心",
            notReturnBtn:false,
            headerBg:false,
        },
    },
]
export default additionalRecordingPage